import { Cache } from "aws-amplify/utils";

// enum
import { ENUM_USER_ATTRIBUTES_CACHE_KEY } from "./enum";

const handler = async (payload, { getState, rejectWithValue }) => {
  try {
    const res = await Cache.getItem(ENUM_USER_ATTRIBUTES_CACHE_KEY);
    if (res) return res;

    console.log('services.user.getCachedUser@handler', 'User attributes not found in local cache');
    return {
      user_id: null,
      name: null,
      email: null,
      picture: null,
      phone_number: null,
      last_synced: null,
    }

  } catch (error) {
    return rejectWithValue(error);
  }
}

const pending = (state, action) => {
  return {
    ...state,
    initialized: false,
  };
}

const fulfilled = (state, action) => {
  return {
    ...state,
    ...action.payload,
    initialized: false,
  };
}

const rejected = (state, action) => {
  return {
    ...state,
    initialized: false,
  };
}

export default {
  handler,
  pending,
  fulfilled,
  rejected
}